import { useEffect, useState, useRef } from 'react';
import { 
    StylesFilter, 
    StylesFilterMob,
    StylesFilter_formal, 
    StylesFilterMob_formal, 
    StylesFilter_kurta,
    StylesFilterMob_kurta,
    StylesFilterMob_Blazer,
    StylesFilter_Blazer} from '../../Data/index';

import { ReactSVG } from "react-svg";
import '../Resources/resources.css'

import '../svg_s.css'
import { changeImgState, checkCategory, checkStyleConditions, enableStyleSelection, getOrderedButtons } from '../../Functions';
import more_options_icon from '../../assets/icon/more_options.svg'
import TuxedoSelector from './tuxedoSelector';

function StyleP({ category ,sel, setNav, setLoad, menuOpen, setMenuOpen, getStyleImg, setImgState , setIndication, setJodh , jodh, imgState, Navs, Buttons, Tuxedo, setSelectStyleItem }) {
    const [on, setOn] = useState(1);
    const sidebarRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
    const [isExpanded, setIsExpanded] = useState(false);

    const [useFilter, setUseFilter] = useState(
        category === "suit" ? StylesFilter
        : category === "formal" || category === "pant" || category === "shirt" ? StylesFilter_formal
        : (category === "kurta" || category === "sadri") ? StylesFilter_kurta  
        : category === "blazer" ? StylesFilter_Blazer
        : StylesFilter
    )
    const toggleSidebar = () => {
        setIsExpanded(!isExpanded);
    };
    

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 480);
        };

        if(window.innerWidth < 480){

            setUseFilter(
                category === "suit" ? StylesFilterMob
                : category === "formal" || category === "pant" || category === "shirt" ? StylesFilterMob_formal
                : (category === "kurta" || category === "sadri") ? StylesFilterMob_kurta 
                : category === "blazer" ? StylesFilterMob_Blazer
                : StylesFilterMob   
            )
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [window.innerWidth]);

    const getButtonsList = ()=>{
        if(!Buttons.length) return []
        const buttons = [];

        // if(category === "suit"){
        //     const curr_id = sel.fabric?.Coat?.button
        //     const curr_button = Buttons.find(item => item.id === curr_id)
        //     if(curr_button){
        //         buttons.push({
        //             name : curr_button.name,
        //             src : curr_button.src
        //         })
        //     }
        // }
        buttons.push(sel["button"] ? sel.button : Buttons[0])

        buttons.push({
            name : 'More options',
            src : more_options_icon,
            action : "button"
        })
        return buttons;
    }

    const isTuxedoButton = (value)=>{
        if(category === "suit"){
           const a = sel.style?.Coat?.F[0]
           return (["1B", "2B", "3B"].includes(a) && value.type === "Single Brested - Tuxedo" || 
           ["4B", "6B"].includes(a) && value.type === "Double Brested - Tuxedo") && sel.tuxedo
        }
    }
    

    return (
        <div>
            <div className={`styleSection ${isMobile ? (menuOpen ? 'show' : 'hidden') : ''}`} ref={sidebarRef}>
                {isMobile && (
                    <div>
                        
                        <span className="close-sidebar" onClick={() => setMenuOpen(false)}>&times;</span>
                    </div>
                )}
                <div className='s-filter-wrapper'>
                    {useFilter && useFilter.map((value, key) => {
                        // Global Category Hiding Logic
                        if (category === "kurta" && sel && sel.style && sel.style.Kurta) {
                             const sleeve = sel.style.Kurta.F[8];
                             if (value.type === "Cuff Style" && sleeve === "SN") return null;
                        }

                        return (
                        <>
                            {(sel && sel.types && sel.types.includes(value.name) || value.name === "Tuxedo") && (
                                <div className={`s-filter-body button3-50'} ${checkStyleConditions(sel, value, jodh) ? 'opacity_03' : ''}`}
                                    // style={jodh && value.type ==="Lapel" ? {opacity:"0.5"}:{}}
                                    id={`style_type_${value.place}`}
                                >
                                    {/* <label
                                        style={{"padding":"3px 8px", "background":"#14213D", "color":"white","width":"fit-content", "fontSize":"0.7rem", "marginBottom":"0", "borderRadius":"5px"}}
                                    >Coat </label> */}
                                    { value["place"] && <div
                                        style={{"opacity":"1", "padding":"3px 8px", "background":"#14213D", "color":"white", "marginBottom":"10px", "borderRadius":"5px", "textAlign":"center"}}
                                    >{value["place"]} </div>}
                                    
                                    {!Object.hasOwn(value, "hdr") && <div className='txt-font'>  {value.type} </div>}
                                    {Object.hasOwn(value, "sub") && <div className='txt-font1'> {value.sub} </div> }
                                    {Object.hasOwn(value, "action") && isTuxedoButton(value) && 

                                        ( <div>
                                            {value.category === "tuxedo" ? 
                                            <TuxedoSelector
                                                Tuxedo={Tuxedo}
                                                sel={sel}
                                                getStyleImg={getStyleImg}
                                                isMobile={isMobile}
                                                setLoad={setLoad}
                                                setSelectStyleItem = {setSelectStyleItem}
                                            />
                                            : 
                                                <button className='Butt1 style_selection_button'
                                                    onClick={()=>{
                                                        setSelectStyleItem(value["category"] ? value["category"] : null)
                                                    }}
                                                > <span>{value.action}</span> </button>  
                                            }
                                            
                                        </div>
                                        )
                                    }
                                    <div className={`s-filter-type button-50'}`}>
                                         {value.attr.map((val, k) => (
                                            <div className={`s-filter-row button2-50'}`} key={k}>
                                                {val.map((val1, k1) => {
                                                    // CONDITIONAL RENDERING LOGIC
                                                    
                                                    // 1. Length Logic
                                                    if (value.type === "Length" && value.name === "Kurta") {
                                                        const currentLength = sel.style?.Kurta?.F[10];
                                                        const isShortActive = ["S", "P_S", "QS_S"].includes(currentLength);
                                                        
                                                        if (["P_S", "QS_S"].includes(val1.value)) {
                                                            if (!isShortActive) return null; // Hide if Short is not selected
                                                        }
                                                    }

                                                    // 2. Neck Placket Logic
                                                    if (value.type === "Neck Placket" && value.name === "Kurta") {
                                                        const currentLength = sel.style?.Kurta?.F[10];
                                                        const isShortLength = ["S", "P_S", "QS_S"].includes(currentLength);
                                                        
                                                        if (["QS_SP", "NS_SK"].includes(val1.value)) {
                                                            if (!isShortLength) return null; // Hide if Length is not Short
                                                        }
                                                    }

                                                    // 3. Cuff Style Logic - Hide if Sleeve is "No Cuff"
                                                    if (value.type === "Cuff Style" && value.name === "Kurta") {
                                                        const sleeve = sel.style?.Kurta?.F[8]; // Sleeve is at index 8
                                                        if (sleeve === "SN") return null; // Hide if No Cuff
                                                    }
                                                

                                                    return (
                                                    <div
                                                        key={k1} // Added key here for mapped element
                                                        type = {(!checkStyleConditions(sel, value, jodh, val1)) ? 'button':""} 
                                                        className={(!checkStyleConditions(sel, value, jodh, val1) && enableStyleSelection(sel, value, val1)) ? 's-f-card-h' 
                                                            : checkStyleConditions(sel, value, jodh, val1) ? 'dis_hov s-f-card' 
                                                            : 's-f-card'}
                                                        onClick={async () => {
                                                            if (on === 1) {
                                                                if ( checkStyleConditions(sel, value, jodh, val1)
                                                                    || enableStyleSelection(sel, value, val1)) {
                                                                    console.log("Selecting same thing again");
                                                                } else {
                                                                    if(value["name"] === "Coat" && val1["value"][0] === "J"){
                                                                        // setIndication(true)
                                                                        setJodh(true)
                                                                        // console.log("Setting Jodh")
                                                                    } else if(value["name"] === "Pant" && (val1["value"] === "F-SP" || val1["value"] === "F-DP") ){
                                                                        setJodh(true)
                                                                    }
                                                                    else{
                                                                        setJodh(false)
                                                                    }


                                                                    
                                                                    
                                                                    

                                                                    let arr = sel["style"][value["name"]][value["pos"]]
                                                                    arr[value["n"]] = val1["value"].toString().startsWith("T-") ? val1["value"].slice(2) : val1["value"]
                                                                    
                                                                    

                                                                    let obj = {...sel}
                                                                    obj["style"][value["name"]][value["pos"]] = arr

                                                                    if(val1["value"].toString().startsWith("T-")){

                                                                        obj["tuxedo"] = obj.tuxedo ? {...obj.tuxedo} : Tuxedo[0];

                                                                    } else if(value["name"]=== "Coat" && value["n"] === 0 && obj.tuxedo) {
                                                                        delete obj.tuxedo;
                                                                    }

                                                                    
                                                                    
                                                                    if(value["name"] === "Shirt" && value["type"]==="Sleeve"){
                                                                        if(val1["value"] === "F"){
                                                                            
                                                                            obj.style.Shirt.B[0] = obj.style.Shirt.B[0][obj.style.Shirt.B[0].length-1]
                                                                        } else {
                                                                            obj.style.Shirt.B[0] = "H" + obj.style.Shirt.B[0]
                                                                        }
                                                                    }

                                                                    if( (obj && obj.style && obj.style.Pant && obj.style.Pant.F[1] === "R") &&
                                                                        (obj.style.Pant.F[0] === "F-DP" || obj.style.Pant.F[0] === "F-SP")
                                                                    ){
                                                                        obj.style.Pant.F[1] = "C"
                                                                    }
                                                                    
                                                                    setLoad(true)

                                                                    var L = changeImgState(obj, value["name"], value["pos"], setImgState, setLoad, category, imgState, value["type"]);
                                                                    
                                                                    console.log("from Style :", obj)
                                                                    await getStyleImg(obj , L, [value["name"]])
                                                                    
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {/* <img src={val1.img} className='s-f-img' /><br /> */}
                                                        {/* {val1.img} */}
                                                        {/* <svg className='s-f-img'>
                                                        
                                                        {val1.img}
                                                        </svg><br /> */}
                                                        <ReactSVG src={val1.img} className={`s-f-img ${(enableStyleSelection(sel, value, val1) && !( checkStyleConditions(sel, value, jodh, val1)  ) ) ? `filter_svg` : ''} `}
                                                        />
                                                        <div className={enableStyleSelection(sel, value, val1) && !( checkStyleConditions(sel, value, jodh, val1) )? 'sel_style_txt' : 'not_sel_txt'}>
                                                            {val1.name}
                                                        </div>
                                                    </div> 
                                                    )
                                                })}
                                            </div>
                                        ))} 
                                        

                                        {value.place === "Button" ?
                                        <>
                                        <div className='button_selection_info'>
                                            
                                                {getButtonsList().map((button, index)=>{
                                                    return <div 
                                                        key={index} 
                                                        className={`s-f-card button_selected ${button.recom ? "button_recom" : ""}`}
                                                        onClick={()=>{
                                                            if(button.action){
                                                                setSelectStyleItem("button")
                                                            }
                                                        }}
                                                    >
                                                        <div>
                                                            <img src={button.src} className='s-f-img' alt={button.name ? button.name : "Button Image"}/>
                                                        </div>
                                                        <label className="sel_style_txt">{button.name ? button.name : "Button "+(index+1)}</label>
                                                    </div>
                                                    })
                                                }
                                        </div> 
                                        </>
                                        : <></>
                                        }
                                    </div>
                                </div>
                            )}
                        </>
                    )})}
                </div>
            </div>
        </div>
    );
}

export default StyleP;
